module.exports = __webpack_public_path__ + "static/Alaska4Sm-3a3e657084a756c19d295c56ab4b7f7b.jpg";